(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('SubcategoryDeleteController',SubcategoryDeleteController);

    SubcategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Subcategory'];

    function SubcategoryDeleteController($uibModalInstance, entity, Subcategory) {
        var vm = this;
        vm.subcategory = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            Subcategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
